import * as React from "react";
import { observer } from "mobx-react-lite";
import * as styles from "./style.module.css";
import I18n from "lib/I18n";
import { getStore } from "bundles/BigqueryQueryViewer/store";

export const Help = observer(() => {
  const app = getStore().app;

  return (
    <div className={styles.root}>
      <ul>
        <li>{I18n.t("bigquery_query_viewer.help.desc1")}</li>
        <li>
          {I18n.t("bigquery_query_viewer.help.desc2")}
          <ul>
            <li>
              {I18n.t("bigquery_query_viewer.help.limit1", {
                default_limit: app.limits.resultRowLimit,
              })}
            </li>
            <li>
              {I18n.t("bigquery_query_viewer.help.limit2", {
                limit: app.limits.recentQueryLimit,
              })}
            </li>
            <li>
              {I18n.t("bigquery_query_viewer.help.limit3", {
                limit: app.limits.quotaPerDayPerUser,
              })}
            </li>
            <li>{I18n.t("bigquery_query_viewer.help.limit4")}</li>
            <li>
              {I18n.t("bigquery_query_viewer.help.limit5", {
                default_limit: app.limits.resultRowLimit,
              })}
            </li>
          </ul>
        </li>
        <li>{I18n.t("bigquery_query_viewer.help.desc3")}</li>
      </ul>
    </div>
  );
});
